import React from 'react';

function CredentialModal({ 
  isOpen, 
  secretKeyInput, 
  credentials,
  onSecretKeyChange, 
  onSubmit, 
  onClose 
}) {
  if (!isOpen) return null;

  return (
    <div className="search-popup-overlay" onClick={onClose}>
      <div className="search-popup" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <div className="search-popup-header">
          <h3>Activate DataTrace API</h3>
          <button className="search-popup-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div className="search-popup-content">
          <p style={{ marginBottom: '15px', color: '#666' }}>
            DataTrace credentials are pre-configured. Enter the last 3 characters of the secret key to activate.
          </p>
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label>Client ID (Pre-configured)</label>
              <input
                type="text"
                value={credentials.clientId}
                disabled
                style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
              />
            </div>
            <div className="form-group">
              <label>Secret Key - Last 3 Characters</label>
              <input
                type="text"
                value={secretKeyInput}
                onChange={(e) => onSecretKeyChange(e.target.value)}
                placeholder="Enter last 3 characters"
                maxLength="3"
                autoFocus
                required
                style={{ fontSize: '16px', padding: '10px' }}
              />
              <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                Partial key: {credentials.partialSecret}***
              </p>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button
                type="button"
                onClick={onClose}
                style={{ flex: 1, padding: '10px', backgroundColor: '#ccc', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={secretKeyInput.length !== 3}
                style={{ flex: 1, padding: '10px', backgroundColor: secretKeyInput.length === 3 ? '#007bff' : '#ccc', color: 'white', border: 'none', borderRadius: '4px', cursor: secretKeyInput.length === 3 ? 'pointer' : 'not-allowed' }}
              >
                Activate DataTrace
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CredentialModal;
